import React from "react";
import Jumbotron from "../../components/jumbotron/Jumbotron";
import Card from "../../components/Card";

const Home = () => {
  return (
    <>
      <Jumbotron />
      <Card />
    </>
  );
};

export default Home;
